import React, { memo, useContext, useEffect, useState } from 'react';
import { Table, ActionIcon, Select, Pagination, Autocomplete, Button, Paper, Text, Box, Flex, Group, Title, Space } from '@mantine/core';
import { IoTrashOutline } from "react-icons/io5";
import { FaRegEdit } from "react-icons/fa";
import classes from "./Draft.module.css";
import { useNavigate } from 'react-router-dom';
import useFetch from '../../../Customhooks/useFetch';
import { baseUrl } from '../../../Constants/constant';
import { useDisclosure } from '@mantine/hooks';
import DeleterowData from './DeleterowData/DeleterowData.component';
import { IoMdSearch } from 'react-icons/io';
import { authContext } from '../../../context/AuthProvider.component';

function Draft() {
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [refresh, setRefresh] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [confirmDeleteOpened, { open: openConfirmDelete, close: closeConfirmDelete }] = useDisclosure(false);
  const [successModalOpened, { open: openSuccessModal, close: closeSuccessModal }] = useDisclosure(false);
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');
  const { setComputeId, setDraftLca, setError } = useContext<any>(authContext);

  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  const {
    data: datalist,
    loading: listLoading,
    error: getlistError,
    fetchData: gettable,
  } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: token,
    },
  });
  const {
    data: deletedata,
    loading: deleteLoading,
    error: getdeleteError,
    fetchData: deletedataapi,
  } = useFetch({
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: token,
    },
  });

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    if (getlistError) {
      setError(getlistError?.message)
    }
  }, [getlistError])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  useEffect(() => {
    gettable(`${baseUrl}compute/lca?page=${page}&limit=${limit}&search=${sendsearch || ''}&is_draft=1`);
  }, [page, limit, sendsearch, refresh]);

  const handleClickEdit = (id: number) => {
    setComputeId(id)
    setDraftLca(1)
    navigate('/newlca/sub-category')
  };

  const handleClickDelete = async (id: number) => {
    setSelectedId(id);
    openConfirmDelete();
  };
  const handleCloseSuccessModal = () => {
    setRefresh(prev => prev + 1);
    closeSuccessModal();
  };

  const rows = datalist?.data?.rows?.map((el: any) => (
    <Table.Tr key={el.id}>
      <Table.Td>{el.file_name}</Table.Td>
      <Table.Td>{el?.report_name}</Table.Td>
      <Table.Td>{el?.product_name}</Table.Td>
      <Table.Td>{el?.created_at.split(' ')[0]}</Table.Td>
      {/* <Table.Td>{el.co2_embedded}</Table.Td> */}
      <Table.Td>
        <ActionIcon
          color="#404040"
          variant="subtle"
          onClick={() => handleClickEdit(el.id)}
        >
          <FaRegEdit size={16} />
        </ActionIcon>
        <ActionIcon
          color="red"
          variant="subtle"
          onClick={() => handleClickDelete(el.id)}
        >
          <IoTrashOutline size={16} />
        </ActionIcon>
      </Table.Td>
    </Table.Tr>
  ));

  const totalPages = Math.ceil((datalist?.data?.count || 0) / limit);
  return (
    <div>
      {/* Loading State */}
      {listLoading && <p>Loading...</p>}

      {/* Error State */}
      {getlistError && <p style={{ color: 'red' }}>Error: {getlistError.message}</p>}
      <>
        <Paper shadow="xs" p="lg" radius="md">
          <Box>
            <Flex
              style={{ justifyContent: 'space-between' }}
              align="center"
            >
              <Box>
                <Title order={3}>Draft</Title>
              </Box>
              <Group>
                <Autocomplete
                  // label="Your favorite library"
                  value={search}
                  onChange={handlechange}
                  placeholder="Search by Draft name"
                  leftSection={<IoMdSearch />}
                />
              </Group>
            </Flex>
            <Space h={'lg'} />
            {/* Table */}
            <Table striped className={classes.customtable}>
              <Table.Thead>
                <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                  <Table.Th>File Name</Table.Th>
                  <Table.Th>Report Name</Table.Th>
                  <Table.Th>Product Name</Table.Th>
                  <Table.Th>Created Date</Table.Th>
                  {/* <Table.Th>CO₂ Embodied</Table.Th> */}
                  <Table.Th>Action</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {datalist?.data?.rows?.length < 1 ? (
                  <Table.Tr>
                    <Table.Td colSpan={4} style={{ textAlign: 'center', fontSize: '17px' }}>No data Available </Table.Td>
                  </Table.Tr>
                ) : (
                  rows
                )}
              </Table.Tbody>
            </Table>

            {/* Pagination */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '20px',
              }}
            >
              <Select
                data={[
                  { value: '5', label: '05 per page' },
                  { value: '10', label: '10 per page' },
                  { value: '20', label: '20 per page' },
                ]}
                value={limit.toString()}
                onChange={(value) => setLimit(Number(value))}
                style={{ width: '150px' }}
              />
              <Pagination
                total={totalPages}
                value={page}
                onChange={setPage}
                color="#404040"
              />
              <DeleterowData
                isConfirmOpen={confirmDeleteOpened}
                isSuccessOpen={successModalOpened}
                closeConfirm={closeConfirmDelete}
                closeSuccess={handleCloseSuccessModal}
                selectedId={selectedId}
                onDeleteSuccess={openSuccessModal}
              />
            </div>
          </Box>
        </Paper>
      </>
    </div>
  );
}

export default memo(Draft);

